import { render, staticRenderFns } from "./Recaptcha.vue?vue&type=template&id=facebd70&scoped=true"
import script from "./Recaptcha.vue?vue&type=script&lang=js"
export * from "./Recaptcha.vue?vue&type=script&lang=js"
import style0 from "./Recaptcha.vue?vue&type=style&index=0&id=facebd70&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facebd70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('facebd70')) {
      api.createRecord('facebd70', component.options)
    } else {
      api.reload('facebd70', component.options)
    }
    module.hot.accept("./Recaptcha.vue?vue&type=template&id=facebd70&scoped=true", function () {
      api.rerender('facebd70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Components/Recaptcha.vue"
export default component.exports